module.exports = __webpack_public_path__ + "static/media/layout-3.686d8f21.jpg";